module.exports = __webpack_public_path__ + "img/pilver-logo.6e247570.svg";